import {connectCurrentRefinements} from 'react-instantsearch-dom';
import {useTranslation} from "react-i18next";

const buttonStyle = {
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#a26700',
    textDecoration: 'underline',
    marginRight: '20px'

}


const ClearRefinements = ({items, refine}) => {

    const {t, i18n} = useTranslation();

    const _onClearRefinements = () => {
        // reset location search
        console.log('items', items);
        refine(items);
        setTimeout(function () {
            document.getElementById('field-address').value = '';
            document.getElementById('field-address').click();
        }, 500);


    }

    return (
        <button style={buttonStyle} onClick={() => _onClearRefinements()} disabled={!items.length}>
            {t('Clear')}
        </button>
    );
}

const ClearFilters = connectCurrentRefinements(ClearRefinements);
export default ClearFilters;
